var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidbaricon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 3H5.8384C6.36884 3 6.87756 3.21071 7.25263 3.58579L9.3335 5.66667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 9H1.3335",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66683 5L7.00016 6.33333C7.36836 6.70153 7.36836 7.29847 7.00016 7.66667C6.63198 8.03487 6.03502 8.03487 5.66683 7.66667L4.66683 6.66667C4.09304 7.24047 3.18464 7.305 2.53546 6.81813L2.3335 6.66667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 7.33317V10.3332C3.3335 11.5902 3.3335 12.2188 3.72402 12.6093C4.11454 12.9998 4.74308 12.9998 6.00016 12.9998H12.0002C13.2572 12.9998 13.8858 12.9998 14.2763 12.6093C14.6668 12.2188 14.6668 11.5902 14.6668 10.3332V8.33317C14.6668 7.0761 14.6668 6.44755 14.2763 6.05703C13.8858 5.6665 13.2572 5.6665 12.0002 5.6665H6.3335",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1668 9.33317C10.1668 9.9775 9.6445 10.4998 9.00016 10.4998C8.35583 10.4998 7.8335 9.9775 7.8335 9.33317C7.8335 8.68884 8.35583 8.1665 9.00016 8.1665C9.6445 8.1665 10.1668 8.68884 10.1668 9.33317Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidbaricon6);
export default __webpack_public_path__ + "static/media/sidbaricon6.c30a674557a2ce5b2f8d2c9cecc28fab.svg";
export { ForwardRef as ReactComponent };